import { render, staticRenderFns } from "./PlayerAttachmentsButton.vue?vue&type=template&id=5731ca9d&scoped=true&"
import script from "./PlayerAttachmentsButton.vue?vue&type=script&lang=js&"
export * from "./PlayerAttachmentsButton.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAttachmentsButton.vue?vue&type=style&index=0&id=5731ca9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5731ca9d",
  null
  
)

export default component.exports